export default __webpack_public_path__ + "static/low.bbdc094707f70d238785e773292890ab.svg";